import { ReactElement, useState, useEffect } from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import ModalConfirmation from "@components/ModalConfirmation";
import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import Table from "@components/Table";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import useListColumns from "@hooks/Clients/WhaleShark/glance/useListColumns";
import deleteGlance from "@services/Clients/WhaleShark/glance/deleteItem";
import { EUiStates } from "@constants/enum";
import Title from "@components/Title";
import useListItems from "@hooks/Shared/useListItems";
import getItems from "@services/Clients/WhaleShark/glance/getItems";
import listMapper from "@mappers/Clients/WhaleShark/glance/ListGlance.mapper";

const ListItems = (): ReactElement => {
  const { t } = useTranslation(["core", "whaleshark"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getItems,
    listMapper,
    true
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`${t("whaleshark:common.glance")} | ${t(
          "core:common.delete_confirm"
        )}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.description
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteGlance);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />

      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
